import { mutatorAction } from 'satcheljs';
import store from '../store/Store';

/**
 * Action to update the time interval frequencny to display bookable times in the store.
 */
export default mutatorAction(
    'SET_PBP_CUSTOM_TIME_INTERVAL',
    function setMeetingTypeCustomTimeInterval(customTimeInterval: number) {
        store.meetingTypeEditState.schedulingPolicy.timeSlotIntervalInMinutes = customTimeInterval;
    }
);
